import { navigate } from "gatsby"
export default (i, extra) => {
  const nome = i.nome.split(" ")[1] + "-" + i.nome.split(" ")[2]
  navigate(`/chirurghi-estetici/${nome}/${extra ?? ""}`)
}
